import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelect2Module } from 'ng-select2';
import { ResumeSendLoginModalComponent } from './resume-send-login-modal/resume-send-login-modal.component';
import { ResumeSendModalComponent } from './resume-send-modal/resume-send-modal.component';
import { ResumeSendComponent } from './resume-send/resume-send.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    ResumeSendComponent,
    ResumeSendLoginModalComponent,
    ResumeSendModalComponent],
  imports: [
    RouterModule,
    NgSelect2Module,
    FormsModule,
    ReactiveFormsModule,
    CommonModule
  ],
  exports: [ResumeSendComponent]
})
export class ResumeSendModalModule { }
